module.exports = "../images/icons/admin/icon-copy.svg";